import { Button } from '@/components/ui/button';
import { BottomBar } from '@/components/BottomBar/BottomBar';
import SvgIcon from '@/components/Icon/SvgIcon';
import { Spinner } from '@/components/ui/spinner';
import i18n from '@/utils/i18n';

interface SaveDiscardBottomBarProps {
  visible: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export function SaveDiscardBottomBar({
  visible,
  saving,
  onSave,
  onDiscard,
}: SaveDiscardBottomBarProps) {
  if (!visible) return null;

  return (
    <BottomBar>
      <div className="tw:w-full tw:flex tw:gap-2 tw:p-6 tw:justify-between tw:bg-sidebar tw:border-t tw:border-sidebar-border">
        <div className="tw:flex tw:items-center tw:gap-2">
          <SvgIcon name="light-bulb-idea" size={16} />
          <span>{i18n.t('Common:saveChangesPrompt')}</span>
        </div>
        <div className="tw:flex tw:gap-2">
          <Button variant="destructive" disabled={saving} onClick={onDiscard}>
            {i18n.t('Common:discard')}
          </Button>
          <Button disabled={saving} onClick={onSave}>
            {saving && <Spinner />}
            {i18n.t('Common:saveChanges')}
          </Button>
        </div>
      </div>
    </BottomBar>
  );
}
